<template lang="pug">
.wrapper
  AppDialog(
    v-show="showDialog"
    size="medium"
    position="centered"
    append-to-body
    has-footer
    title="Shift"
    :show="show"
    @close="close"
  )
    template(v-if="event.canViewStatus" #titleLabel)
      .label.shift-status(:class="statusClass") {{ event.shiftStatus }}

    .d-flex.align-items-center.justify-content-between
      .d-flex.align-items-center
        HubAvatar(
          :user-id="shift.userId"
          :users-avatars="usersAvatars"
          avatar-style="thumb"
        )
        span.ml-5 {{ event.userRealName }}

      .text-right {{ shift.range }}
        .text-grey {{ shift.formattedStartDate }}

    table.table-condensed.table-borderless.table
      tbody
        tr
          td.no-wrap Minimum hours:
          td.strong.pl-5 {{ shift.minimumHours }}
        tr
          td.no-wrap Time worked:
          td.strong.pl-5 {{ shift.timeWorked }}
        tr(v-if="shift.id")
          td Notes:
          td.strong.shift-notes.pl-5
            .shift-notes-inner {{ shift.notes }}

    template(#footer)
      .d-flex.justify-content-between
        div
          AppButton(
            type="danger"
            :disabled="!shift.canRemove"
            @click="deleteShift"
          ) Delete
        div
          AppButton(
            type="primary"
            :disabled="!canEdit"
            @click="edit"
          ) Edit

    RemoveAttendanceScheduleDialog(
      v-if="showRemoveScheduleDialog"
      :title="removeDialogTitle"
      :shift="shift"
      :event="event"
      @close="close"
    )

    EditAttendanceScheduleOptionsDialog(
      v-if="showEditOptionsScheduleDialog"
      :event="event"
      @close="close"
      @delete-shift="deleteShift"
    )

    ScheduleDialog#edit-schedule-form(
      v-if="showEditScheduleDialog"
      key="edit-schedule-dialog"
      editing
      :editing-attendance-schedule="editingAttendanceSchedule"
      :event="event"
      :date-range="editScheduleDateRange"
      :model-type="modelType"
      @close="close"
      @delete-shift="deleteShift"
    )
</template>

<script>
import RemoveAttendanceScheduleDialog from '~/components/attendance_schedules/dialogs/RemoveAttendanceScheduleDialog.vue';
import EditAttendanceScheduleOptionsDialog from '~/components/attendance_schedules/dialogs/EditAttendanceScheduleOptionsDialog.vue';
import ScheduleDialog from '~/components/attendance_schedules/dialogs/ScheduleDialog.vue';
import { createUsersAvatarsMixin } from '~/mixins/UsersAvatarsMixin';
import { AttendanceSchedulesResource } from '~/resources';
import { mapInertiaProps } from '~/utils/inertia';

export default {
  name: 'AttendanceShiftDialog',
  components: { RemoveAttendanceScheduleDialog, ScheduleDialog, EditAttendanceScheduleOptionsDialog },
  mixins: [createUsersAvatarsMixin('assignedMember')],
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    event: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    showRemoveScheduleDialog: false,
    showEditOptionsScheduleDialog: false,
    showDialog: true,
    editingAttendanceSchedule: null,
    showEditScheduleDialog: false,
    editScheduleDateRange: {},
  }),
  computed: {
    ...mapInertiaProps({
      members: ({ calendar_resources: calendarResources }) => calendarResources.users,
    }),
    shift() {
      return this.event.shiftAttributes;
    },
    assignedMember() {
      return this.members.filter((user) => this.shift.userId === user.id);
    },
    removeDialogTitle() {
      if (!this.shift.attendanceScheduleId) {
        return 'Delete shift';
      }

      return this.shift.isRecurring ? 'Remove recurring shifts' : 'Remove schedule';
    },
    statusClass() {
      return this.event.shiftStatus.toLowerCase();
    },
    canEdit() {
      return this.shift.canEdit;
    },
    modelType() {
      return this.shift.id ? 'Shift' : 'Schedule';
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    deleteShift() {
      this.showDialog = false;
      this.showRemoveScheduleDialog = true;
      this.showEditScheduleDialog = false;
    },
    edit() {
      this.shift.id ? this.handleEditShift() : this.retrieveScheduleDetails();
    },
    handleEditShift() {
      if (this.shift.isRecurring) {
        this.showDialog = false;
        this.showEditOptionsScheduleDialog = true;

        return;
      }

      this.retrieveScheduleDetails();
    },
    async retrieveScheduleDetails() {
      await AttendanceSchedulesResource.edit({
        scheduleId: this.shift.attendanceScheduleId,
      })
        .then((response) => {
          this.editingAttendanceSchedule = response;

          // Use shift minimum hours if the shift is being edited
          if (this.shift.id) {
            const [hours, minutes] = this.shift.minimumHours.split(':');

            this.editingAttendanceSchedule.minimum_hours =
              Number(hours) + Math.round((Number(minutes) / 60) * 100) / 100;
          }

          const startDate = new Date(this.shift.date) > new Date() ? response.start_date : this.shift.date;
          const stopDate = new Date(this.shift.stop_date) > new Date() ? response.stop_date : this.shift.stop_date;
          const startTime = moment.tz(this.shift.start_time, this.shift.time_zone).format('hh:mm A');
          const stopTime = moment.tz(this.shift.stop_time, this.shift.time_zone).format('hh:mm A');

          this.editScheduleDateRange = {
            start: moment(`${startDate} ${startTime}`, 'YYYY-MM-DD hh:mm A'),
            stop: moment(`${stopDate} ${stopTime}`, 'YYYY-MM-DD hh:mm A'),
          };
        })
        .finally(() => {
          this.showDialog = false;
          this.showEditScheduleDialog = true;
        });
    },
    closeRemoveScheduleDialog() {
      this.close();
    },
  },
};
</script>
